import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const breadcrumbMap: Record<string, string> = {
  'qinggan-gushi': '情感故事',
  'richang-shenghuo': '日常生活',
  'xiangchu-zhidao': '相处之道',
  'zhenshi-tiyan': '真实体验',
  'qinggan-gongming': '情感共鸣',
  'chengzhang-jilu': '成长记录',
};

export default function Breadcrumb() {
  const location = useLocation();
  const paths = location.pathname.split('/').filter(Boolean);

  if (paths.length === 0) return null;

  const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (paths[0] === 'category' && paths[1]) {
    items.push({
      label: breadcrumbMap[paths[1]] || paths[1],
      href: `/category/${paths[1]}`,
    });
  } else if (paths[0] === 'article' && paths[1]) {
    items.push({ label: '文章详情' });
  } else if (paths[0] === 'about') {
    items.push({ label: '关于我们', href: '/about' });
  }

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <div className="max-w-6xl mx-auto flex items-center gap-2 text-xs text-foreground-500">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400" />
            )}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </span>
        ))}
      </div>
    </nav>
  );
}